import React from 'react';
import PropTypes from 'prop-types';
import ApolloLinkTimeout from 'apollo-link-timeout';
import ApolloClient from 'apollo-client';
import {createUploadLink} from 'apollo-upload-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {ApolloProvider} from '@shopify/react-graphql';
import getCSRFToken from 'utilities/security/token-fetcher';

const headers = {
  'X-CSRF-Token': getCSRFToken(),
  Accept: 'application/json',
};

export function getClient(options = {}) {
  const timeoutLink = new ApolloLinkTimeout(10000);
  const uploadLink = createUploadLink({
    uri: `/${options.organizationID}/api/graphql`,
    credentials: 'same-origin',
    headers,
  });
  const link = timeoutLink.concat(uploadLink);
  const cache = new InMemoryCache();
  return new ApolloClient({link, cache});
}

export function Provider({organizationID, children}) {
  return (
    <ApolloProvider client={getClient({organizationID})}>
      {children}
    </ApolloProvider>
  );
}

export function getInternalClient() {
  const link = createUploadLink({
    uri: `/api/internal/graphql`,
    credentials: 'same-origin',
    headers,
  });
  const cache = new InMemoryCache();
  return new ApolloClient({link, cache});
}

export function InternalProvider({children}) {
  return (
    <ApolloProvider client={getInternalClient()}>{children}</ApolloProvider>
  );
}

export function getAdPlatformClient(options = {}) {
  const link = createUploadLink({
    uri: `/${options.organizationID}/api/ad_platform_graphql`,
    credentials: 'same-origin',
    headers,
  });
  const cache = new InMemoryCache();
  return new ApolloClient({link, cache});
}

export function getServicesMarketplacePublicClient() {
  const link = createUploadLink({
    uri: `/api/graphql`,
    credentials: 'same-origin',
    headers,
  });
  const cache = new InMemoryCache();
  return new ApolloClient({link, cache});
}

export function ServicesMarketplacePublicProvider({children}) {
  return (
    <ApolloProvider client={getServicesMarketplacePublicClient()}>
      {children}
    </ApolloProvider>
  );
}

export function AdPlatformProvider({organizationID, children}) {
  return (
    <ApolloProvider client={getAdPlatformClient({organizationID})}>
      {children}
    </ApolloProvider>
  );
}

export function nodesFromEdges(edges) {
  return edges.map(({node}) => node);
}

Provider.propTypes = {
  organizationID: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
};
